import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

export type BlogLayout = 'inline' | 'drawer-featured' | 'drawer-grid';

const STORAGE_KEY = 'blog.layout';
const DEFAULT_LAYOUT: BlogLayout = 'inline';
const VALID: ReadonlyArray<BlogLayout> = ['inline', 'drawer-featured', 'drawer-grid'];

@Injectable({ providedIn: 'root' })
export class LayoutPreferenceService {
  private readonly subject = new BehaviorSubject<BlogLayout>(this.read());

  readonly layout$: Observable<BlogLayout> = this.subject.asObservable();

  get current(): BlogLayout {
    return this.subject.value;
  }

  set(layout: BlogLayout): void {
    if (!VALID.includes(layout)) return;
    if (layout === this.subject.value) return;
    try { localStorage.setItem(STORAGE_KEY, layout); } catch { /* private mode etc. */ }
    this.subject.next(layout);
  }

  private read(): BlogLayout {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      if (raw && (VALID as ReadonlyArray<string>).includes(raw)) return raw as BlogLayout;
    } catch { /* noop */ }
    return DEFAULT_LAYOUT;
  }
}
